export default {
  rewards(state) {
    return state.rewards;
  },
  approvalRewards(state) {
    return state.approvalRewards;
  }
};
